import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import objectSupport from 'dayjs/plugin/objectSupport';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';

import { t } from '../services/translation/translation';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(objectSupport);
dayjs.extend(weekday);

export const isParisTz = () => {
  const now = dayjs();
  return now.diff(now.tz('Europe/Paris', true), 'hours') === 0;
};

export const localDateToTzDate = (localDate: string, timezone: string) => dayjs.tz(localDate, timezone).valueOf();

export const parseDate = (date: string, parseFormatString: string) => dayjs(date, parseFormatString).valueOf();

export const formatDate = (date: number, formatString: string) => dayjs(date).format(formatString);

export const formatDateForParisTZ = (date: number, formatString: string, withSuffix = true) => {
  const formattedDate = dayjs(date).tz('Europe/Paris').format(formatString);
  return `${formattedDate}${withSuffix && !isParisTz() ? t('common.local-time') : ''}`;
};

export const dateDiff = (from: Date | number, to: Date | number, unit: dayjs.OpUnitType) => dayjs(from).diff(to, unit);

export const formatTimeBySeconds = (value: number) => {
  const h = Math.floor(value / 60)
    .toString()
    .padStart(2, '0');
  const m = Math.floor(value % 60)
    .toString()
    .padStart(2, '0');
  return `${h}:${m}`;
};

export const dateAdd = (date: Date | number, amount: number, unit: dayjs.ManipulateType) =>
  dayjs(date).add(amount, unit);

export const formatRelativeDate = (from: number, to: number) => {
  const fromDate = dayjs(from);
  const toDate = dayjs(to);
  const diff = fromDate.diff(toDate, 'minutes');

  return diff < 0 ? t('common.now') : dayjs.duration({ minutes: diff }).humanize(true);
};

export const isPast = (date: Date | number) => dayjs(date).isBefore(Date.now());

export const getParisTzOffset = () => {
  const now = dayjs();
  return now.tz('UTC', true).diff(now.tz('Europe/Paris', true), 'minutes');
};

export const hoursValues = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23];
export const minutesValues = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];

export const format = (value: number) => ({ label: `${value}`.padStart(2, '0'), value });

export const hoursOptions = hoursValues.map(format);
export const minutesOptions = minutesValues.map(format);

export function parisLocalDate(date: number | Date | string): dayjs.Dayjs {
  return dayjs.tz(date, 'Europe/Paris');
}
